export default __webpack_public_path__ + "static/Painting_Canvas-a90193fa792d27f82142fc57a0b6465c.png";